/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

import styled from "@mui/styled-engine-sc";
import PaginationItem from "@mui/material/PaginationItem";

/**
 * Styled component on @material-ui
 * @see https://material-ui.com/api/pagination-item/
 */
const StyledPaginationItem = styled(({ ...props }) => <PaginationItem {...props} />)`
  && {
  }
`;

export { StyledPaginationItem };
